/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import { ROUTES } from '@sportninja/common/constants/app'
import { Link } from 'react-router-dom'
import { GameListRowV2Props } from './types'
import { cardContainerStyles, contentRowStyles } from './styles'
import useGameCardState from './hooks/useGameCardState'
import HeaderBar from './components/HeaderBar'
import { resolveVisitingTeamDisplay } from '@sportninja/common/features/game/placeholderVisitor/resolveVisitingTeamDisplay'
import TeamSection from './components/TeamSection'
import ScoreDisplay from './components/ScoreDisplay'
import CenterInfo from './components/CenterInfo'

const GameListRowV2 = ({
  game,
  gameTypes,
  gameStatusTypes,
  hasNextSibling,
  isSoccer = false,
  isHockey = false,
  isFirstGame = false,
  onClickFirstGame = () => {},
  scheduleId = null,
  isMySchedule = false,
}: GameListRowV2Props) => {
  const {
    gameState,
    userRole,
    currentPeriod,
    timezoneData,
    fullGameType,
    statusText,
    showHeader,
  } = useGameCardState({
    game,
    gameTypes,
    gameStatusTypes,
    isSoccer,
    isHockey,
  })

  const handleClick = async () => {
    if (isFirstGame) {
      try {
        await onClickFirstGame()
      } catch (error) {
        // Silently catch — onClickFirstGame is an optional UX callback
      }
    }
  }

  return (
    <Link
      to={`${ROUTES.GAME_ROOT}/${game.id}`}
      id={isFirstGame ? 'sandbox-schedule-games' : undefined}
      onClick={handleClick}
      css={css`
        text-decoration: none;
        display: block;
        ${hasNextSibling && 'margin-bottom: 16px;'}
      `}
    >
      <div css={cardContainerStyles(false)}>
        {showHeader && <HeaderBar gameState={gameState} userRole={userRole} />}
        <div css={contentRowStyles}>
          <TeamSection
            team={game.homeTeam}
            teamSlot={game.homeTeamSlot}
            isHome
            scheduleId={
              isMySchedule ? game.rootSchedule?.id || null : scheduleId
            }
          />
          {gameState.gameHasScores && (
            <ScoreDisplay
              score={game.home_team_score}
              isWinner={gameState.homeTeamWon}
            />
          )}
          <CenterInfo
            game={game}
            fullGameType={fullGameType}
            gameState={gameState}
            currentPeriod={currentPeriod}
            timezoneData={timezoneData}
            isMySchedule={isMySchedule}
            statusText={statusText}
          />
          {gameState.gameHasScores && (
            <ScoreDisplay
              score={game.visiting_team_score}
              isWinner={gameState.visitingTeamWon}
            />
          )}
          <TeamSection
            team={game.visitingTeam}
            teamSlot={game.visitingTeamSlot}
            placeholderName={resolveVisitingTeamDisplay(game).name}
            isHome={false}
            scheduleId={
              isMySchedule ? game.rootSchedule?.id || null : scheduleId
            }
          />
        </div>
      </div>
    </Link>
  )
}

export default GameListRowV2
